"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBillablePeriodEndDatesLegacyQuery = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var core_1 = require("../../../core");
var query = "query ListBillablePeriods($id: String!) { billingSummary(id: $id) { billablePeriods { end isStatementAvailable closingBalance { pounds } } } }";
function useBillablePeriodEndDatesLegacyQuery(accountId) {
    var api = core_1.configService.getConfig().api;
    var billingEndpoint = "".concat(api.baseUrl, "/bal/api/graphql");
    return (0, ui_tools_1.useReactQuery)("cx-billable-period-end-dates-".concat(accountId), function () {
        return core_1.apiService
            .graphql({
            url: billingEndpoint,
            body: {
                query: query,
                variables: { id: accountId },
                operationName: 'ListBillablePeriods',
            },
        })
            .then(function (data) { return data.billingSummary; });
    });
}
exports.useBillablePeriodEndDatesLegacyQuery = useBillablePeriodEndDatesLegacyQuery;
